<template>
    <new-program v-if="openNewProgram" @closeModal="openNewProgram = false" :itemId="item.id" />
    <div class="customCard">
        <div class="customCard__left">
            <swiper class="customCard__left__swiper" :slidesPerView="1" :speed="1000" :autoplay="true" :pagination="{
                clickable: true,
            }" :lazy="true" :loop="true">
                <swiper-slide v-for="(img) in item?.images" :key="img" class="customCard__left__swiper__slide" id="programSwiper">
                    <img :src="img.image" alt=""/>
                </swiper-slide>
            </swiper>
            <div class="bilim" v-if="item?.is_student_choose == true">
                <img src="@/assets/icons/bilim.svg" />
                <p>ВЫБОР СТУДЕНТА</p>
            </div>
        </div>
        <div class="customCard__right">
            <div class="customCard__right__top">
                <p class="customCard__right__top__name">{{ item?.university }}</p>
                <p
                    class="customCard__right__top__spec"
                    @click="!isAdmission ? $router.push({
                        name: 'program',
                        params: { id: item.id }
                    }) : changeAdmission()"
                >{{ item?.programName }}</p>
            </div>
            <div class="line"></div>
            <div class="customCard__right__rate">
                <p v-if="item?.top">{{ item?.top }}</p>
                <span v-if="item?.subcategory?.category?.title">{{ item?.subcategory?.category?.title }}</span>
            </div>
            <div class="customCard__right__buttons" v-if="isFavorite">
                <button class="customCard__right__buttons__red" @click="$router.push({
                    name: 'program',
                    params: { id: item.id },
                })">Подробнее</button>
            </div>
            <div class="customCard__right__buttons" v-else>
                <button class="customCard__right__buttons__red" v-if="isAdmission"
                    @click="changeAdmission()">Редактировать</button>
                <button class="customCard__right__buttons__red" v-if="isAdmission == null && isWait == null"
                    @click="$router.push(userName ? { name: 'program', params: { id: item.id }, query: { user_name: userName } } : { name: 'program', params: { id: item.id }, query: {} })">Подробнее</button>
                <button class="customCard__right__buttons__fav"
                    v-if="$store.state.role == 'user' && item.is_favourite == 0 && isAdmission == null"
                    @click.prevent="addToFav(item.id)">
                    <img src="@/assets/icons/greyHeart.svg" />
                    <p>В избранное</p>
                </button>
                <button class="customCard__right__buttons__fav"
                    v-if="$store.state.role == 'user' && item.is_favourite == 1 && isAdmission == null"
                    :class="{ customFav: item.is_favourite == 1 }" @click="deleteFromFav(item.id)">
                    <img src="@/assets/icons/fullHeart.svg" />
                    <p>Убрать</p>
                </button>
                <button class="customCard__right__buttons__inAdmiss"
                    v-if="($store.state.role == 'expert') && isAdmission == true" @click="deleteFromAdmission()">
                    <p>Убрать</p>
                </button>
                <!-- <button class="customCard__right__buttons__admiss"
                    v-if="($store.state.role == 'expert') && isAdmission == null && isClient" @click="toAdmission()">
                    <img src="@/assets/icons/admission.svg" />
                    <p>В поступление</p>
                </button> -->
              <select
                  class="customCard__right__buttons__admiss"
                  v-if="$store.state.role == 'expert' && isAdmission == null && isClient && !selectPriorityChief[item.id]"
                  v-model="selectPriority"
                  @change="onPriorityChange(item.id)"
              >
                <option v-for="option in priority" :key="option.id" :value="option.id">{{ option.id }}</option>
              </select>
                <select
                    class="customCard__right__buttons__admiss"
                    v-if="isAdmission == null && isClient && selectPriorityChief[item.id]"
                    v-model="selectPriorityChief[item.id]"
                    disabled
                >
                    <option v-for="option in priority" :key="option.id" :value="option.id">{{ option.id }}</option>
                </select>
              <select
                  class="customCard__right__buttons__admiss"
                  v-if="$store.state.role == 'chief' && isAdmission == true"
                  v-model="selectPriorityChief[item.id]"
                  @change="changePriorityChief(selectPriorityChief[item.id], item.id)"
              >
                <option v-for="option in priority" :key="option.id" :value="option.id">{{ option.id }}</option>
              </select>
                <input type="checkbox" class="customCard__right__buttons__input"
                    v-if="($store.state.role == 'expert') && isAdmission == null && isClient && !selectPriorityChief[item.id]"
                    @click="cardForChief(item.id)" />
                <input type="checkbox" class="customCard__right__buttons__input"
                       v-if="isAdmission == null && isClient && selectPriorityChief[item.id]" checked disabled/>
                <!-- <button class="customCard__right__buttons__admiss" v-if="($store.state.role == 'curator' || $store.state.role == 'expert' ) && isWait" disabled>
                    <img src="@/assets/icons/clock.svg"/>
                    <p>В ожидании</p>
                </button> -->
                <button class="customCard__right__buttons__admiss"
                    v-if="($store.state.role == 'curator' || $store.state.role == 'expert') && isWait"
                    style="background-color: #FD2D2A; color: white;" @click="openNewProgram = true">
                    <img src="@/assets/icons/edit.svg" />
                    <p>Редактировать</p>
                </button>
            </div>
        </div>
        <div class="block w-fit sm:hidden">
          <button 
            v-if="$store.state.role == 'user' && item.is_favourite == 0 && isAdmission == null"
            @click="addToFav(item.id)"
          >
            <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.7833 19.1417L11.6667 19.2583L11.5383 19.1417C5.99667 14.1133 2.33333 10.7883 2.33333 7.41667C2.33333 5.08333 4.08333 3.33333 6.41667 3.33333C8.21333 3.33333 9.96333 4.5 10.5817 6.08667H12.7517C13.37 4.5 15.12 3.33333 16.9167 3.33333C19.25 3.33333 21 5.08333 21 7.41667C21 10.7883 17.3367 14.1133 11.7833 19.1417ZM16.9167 1C14.8867 1 12.9383 1.945 11.6667 3.42667C10.395 1.945 8.44667 1 6.41667 1C2.82333 1 0 3.81167 0 7.41667C0 11.815 3.96667 15.42 9.975 20.8683L11.6667 22.4083L13.3583 20.8683C19.3667 15.42 23.3333 11.815 23.3333 7.41667C23.3333 3.81167 20.51 1 16.9167 1Z" fill="#FD2D2A"/>
            </svg>
          </button>
          <button 
            v-if="$store.state.role == 'user' && item.is_favourite == 1 && isAdmission == null"
            @click="deleteFromFav(item.id)"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="#FD2D2A" viewBox="0 0 24 24" width="24" height="23">
              <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 
                      2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09
                      C13.09 3.81 14.76 3 16.5 3
                      19.58 3 22 5.42 22 8.5
                      c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
            </svg>
          </button>
        </div>
    </div>
</template>
<script>
import { Swiper, SwiperSlide, } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import SwiperCore, { A11y, Autoplay } from "swiper";
import { Navigation, Pagination } from 'swiper';
import "swiper/swiper.min.css";
SwiperCore.use([Navigation, Pagination, A11y, Autoplay])
import axios from "axios";
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import newProgram from "./newPlatform/newProgram.vue";
import noPhoto from '@/assets/no-photo.png';
import { onMounted, onBeforeUnmount, nextTick, watch } from 'vue';
export default {
    components: {
        Swiper, SwiperSlide, newProgram
    },
    props: ['isFavorite', 'isAdmission', 'item', 'userId', 'userName', 'isClient', 'isWait', 'favouriteStatuses', 'getFavourites', 'mobile'],
    data() {
        return {
            isCurator: true,
            openNewProgram: false,
            selectPriority: null,
            selectPriorityChief: {},
            isChecked: false,
            page: Number(this.$route.query.page) || 1,
            priority: [
                {
                    title: '1',
                    id: 1,
                },
                {
                    title: '2',
                    id: 2,
                },
                {
                    title: '3',
                    id: 3,
                },
                {
                    title: '4',
                    id: 4,
                },
                {
                    title: '5',
                    id: 5,
                },
                {
                    title: '6',
                    id: 6,
                },
                {
                    title: '7',
                    id: 7,
                },
                {
                    title: '8',
                    id: 8,
                },
            ],
        }
    },
    mounted() {
        if (this.getFavourites) {
            this.getFavourites(); // вызов метода родителя при монтировании компонента
        }
        if (this.favouriteStatuses) {
            Object.keys(this.favouriteStatuses).forEach(id => {
                this.selectPriorityChief[id] = this.favouriteStatuses[id];
            });
        }
        console.log(this.favouriteStatuses);

        this.setEqualHeights();
        setTimeout(this.setEqualHeights, 300);
        window.addEventListener('resize', this.setEqualHeights);

        // слушаем загрузку картинок
        document.querySelectorAll('.customCard img').forEach(img => {
            if (!img.complete) img.addEventListener('load', this.setEqualHeights);
        });

        // простой MutationObserver (опционально)
        this._mo = new MutationObserver(this.setEqualHeights);
        document.querySelectorAll('.customCard').forEach(c => this._mo.observe(c, { childList: true, subtree: true }));

        let programSwiper = document.getElementsByClassName('swiper-wrapper');
        Array.from(programSwiper).forEach(wrapper  => {
            // если внутри нет слайдов и нет изображений
            if (!wrapper.querySelector('.swiper-slide')) {
                const slide = document.createElement('div');
                slide.className = 'swiper-slide';

                const img = document.createElement('img');
                img.src = noPhoto;
                img.alt = 'Нет фото';

                slide.appendChild(img);
                wrapper.appendChild(slide);
            }
        })

    },
    beforeUnmount() {
        window.removeEventListener('resize', this.setEqualHeights);
        if (this._mo) this._mo.disconnect();
        document.querySelectorAll('.customCard img').forEach(img => img.removeEventListener('load', this.setEqualHeights));
    },
    methods: {
        setEqualHeights() {
            const cards = document.querySelectorAll('.customCard');
            cards.forEach(card => {
                const left = card.querySelector('.customCard__left');
                const right = card.querySelector('.customCard__right');
                if (!left || !right) return;
                left.style.height = '';
                right.style.height = '';
                const h = right.offsetHeight;
                left.style.height = h + 'px';
            });
        },
        changePriorityChief(priority, id) {
            const data = {
                id: id,
                priority: priority
            }
            if(confirm('Вы уверены что хотите сменить приоритет?')){
                axios.put(`/platform/curator/users/favourites/${this.$route.params.id}`, data, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    }
                })
                .then((res) => {
                    if (res.status === 200) {
                        toast.success('Приоритет успешно изменен.');
                    }
                })
                .catch((err) => {
                    toast.error('Произошла ошибка!')
                })
            }
        },
        changeAdmission() {
            this.$emit('changeAdmission')
        },
        cardForChief(id) {
            this.isChecked = !this.isChecked;

            this.$emit('cardForChief', {
                user_id: parseInt(this.userId),
                program_id: parseInt(id),
                priority: this.selectPriority !== null ? parseInt(this.selectPriority) : null,
                isChecked: this.isChecked
            });
        },
        onPriorityChange(id) {
            if (this.isChecked) {
                this.$emit('cardForChief', {
                    user_id: parseInt(this.userId),
                    program_id: parseInt(id),
                    priority: parseInt(this.selectPriority),
                    isChecked: true
                });
            }
        },
        deleteFromAdmission() {
            if(confirm('Вы уверены что хотите убрать?')) {
                axios.delete(`/platform/curator/users/admissions/${this.$route.params.id}`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    },
                    data: {
                        user_id: this.$route.params.id,
                        university_program_id: this.item.id
                    }
                })
                .then((response) => {
                    if (response.status === 202) {
                        toast.success('Успешно удалено');
                    } else {
                        console.log(response.data);
                    }
                })
                .catch((error) => {
                    if (error.response?.status === 401) {
                        toast.error("Вы не авторизованы");
                    } else {
                        console.log(error.response?.data?.errors || error);
                    }
                });
            }
        },
        addToFav(id) {
            const data = {
                university_program_id: id
            }
            axios.post('/platform/client/users/favourites', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                }
            })
                .then((response) => {
                    if (response.status === 201) {
                        toast.success('Добавлено в избранное')
                        this.item.is_favourite = 1;
                        this.$emit('newFav')
                    } else {
                        console.log(response.data);
                    }
                })
                .catch((response) => {
                    console.log(response.response.data.errors);
                });
        },
        deleteFromFav(id) {
            if(confirm('Вы уверены что хотите убрать?')){
                axios.delete(`/platform/client/users/favourites/${id}`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    }
                })
                .then((response) => {
                    if (response.status === 202) {
                        toast.success('Успешно удалено')
                        this.item.is_favourite = 0;
                        this.$emit('newFav')
                    } else {
                        console.log(response.data);
                    }
                })
                .catch((response) => {
                    console.log(response.response.data.errors);
                });
            }
        },
        toAdmission() {
            const data = {
                user_id: this.userId,
                university_program_id: this.item.id
            }
            axios.post('/platform/curator/users/admissions', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                }
            })
                .then((response) => {
                    if (response.status === 201) {
                        toast.success('Успешно добавлена')
                        this.$emit('newAdmission')
                    } else {
                        console.log(response.data);
                    }
                })
                .catch((response) => {
                    toast.error(response.response.data.message);
                });
        }
    }
}
</script>
<style lang="scss" scoped>
.line {
    border-top: 1px solid #0000001A;
    width: 100%;
}

.customFav {
    color: #FD2D2A;
    border: 1px solid #FD2D2A !important;

    img {
        filter: brightness(0) saturate(100%) invert(38%) sepia(54%) saturate(7060%) hue-rotate(346deg) brightness(100%) contrast(98%);
    }
}

.customCard {
    width: 100%;
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    gap: 12px;

    @media(min-width: 640px) {
      gap: 0;
    }

    &__left {
        width: 30%;
        position: relative;
        height: 100%;

        &__swiper {
            height: 100%;
            width: 100%;

            &__slide {
                height: 100%;
                width: 100%;

                img {
                    width: 100%;
                    height: 100%;
                    aspect-ratio: 1;
                    border-radius: 10px;
                    object-fit: cover;
                }
            }
        }

        .bilim {
            position: absolute;
            z-index: 998;
            background-color: white;
            top: 10px;
            left: 50%;
            width: max-content;
            transform: translate(-50%, 0);
            display: flex;
            gap: 5px;
            color: white;

            img {
                width: 10px;
            }

            p {
                font-size: min(max(6px, calc(0.375rem + ((1vw - 7.68px) * 0.5208))), 12px);
            }

            padding: 5px;
            border-radius: 5px;
            background-color: #FD2D2A;
            align-items: center;
        }
    }

    &__right {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding-left: 20px;

        @media (min-width: 640px) {
          width: 68%;
            padding-left: 20px;
        }

        &__top {
            display: flex;
            flex-direction: column;
            gap: 5px;

            &__name {
                color: #0000008A;
            }

            &__spec {
                font-size: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
                font-weight: 700;
            }
        }

        &__rate {
            font-weight: 700;
            color: #FD2D2A;
            display: flex;
            gap: 10px;
            align-items: center;

            span {
                color: #11415D !important;
            }
        }

        &__buttons {
            display: flex;
            gap: 10px;
            align-items: stretch;
            margin-top: auto;

            button {
                padding: 7px 12px;
                border-radius: 5px;
                font-size: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.3472))), 14px);
                justify-content: center;
                display: flex;
                align-items: center;
                gap: 5px;
                cursor: pointer;

                img {
                    width: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px);
                }
            }

            &__input {
                width: 20px;
                cursor: pointer;
                margin-left: auto;
            }

            &__red {
                background-color: #FD2D2A;
                color: white;
                border: none;
            }

            &__inAdmiss {
                border: 1px solid #FD2D2A !important;
                background-color: white;
                color: #FD2D2A;
                border: none;
            }

            &__admiss {
                border: 1px solid #0000001A !important;
                background-color: white;
                color: #0000008A;
                border: none;
            }

            &__fav {
                background-color: transparent;
                border: 1px solid #00000010;
                border-radius: 10px;
            }
        }
    }

    @media(max-width:768px) {
        margin-bottom: 10px;
        .line{
            display: none;
        }
        &__left {
            width: 32%;

            .bilim {
                padding: 2px;
                font-size: 8px;
            }
        }

        &__right {
            width: 66%;
            gap: 7px;
            padding-left: 10px;

            &__top {
                font-size: min(max(9px, calc(0.5625rem + ((1vw - 7.68px) * 0.434))), 14px);

                &__spec {
                    font-size: 16px!important;
                }
                &__name {
                    font-size: 14px!important;
                }
            }

            &__buttons {
                font-size: min(max(9px, calc(0.5625rem + ((1vw - 7.68px) * 0.434))), 14px);

                button {
                    padding: 5px;
                }

                &__red {
                    width: fit-content;
                    padding: 6px 10px!important;
                    font-size: 14px!important;
                }

                &__fav {
                    display: none !important;
                }
            }
        }
    }
}
</style>